export const paymentRouteNames = {
  legalAndGeneral: 'L&G Mortgage Club',
};
